// import React, { useState } from "react";
// import DropIcon from "components/Icons/DropIcon";
// import SelectDropdown from "./SelectDropdown";

// const FilterDropdown = ({ show, handleClose, setFilterItem,setSearchText }) => {
//   const [showDropdown, setShowDropdown] = useState(false);

//   if (!show) return null;

//   return (
//     <div className='request-logs__filter-dropdown'>
//       <div className='request-logs__filter-dropdown__input-group'>
//         <label className='request-logs__filter-dropdown__label'>{"Active Status"}</label>

//         <div className='request-logs__filter-dropdown__select-dropdown-container'>
//           <p>{"All"}</p>
//           <button onClick={() => setShowDropdown((s) => !s)}>
//             <DropIcon color='#666666' />
//           </button>
//           <SelectDropdown
//             show={showDropdown}
//             onSelect={() => {}}
//             onChange={(e)=>{setFilterItem(e);setSearchText(e==='Pending'?'Initiated':e==='All'?'':e); handleClose(true)} }
//             dropdownItems={["All", "Pending", "Approved", "Rejected", "Failed"]}
//             getTextFromDropdownItem={(text) => text}
//           />
//         </div>
//       </div>

//       {/*<div className='request-logs__filter-dropdown__btns-container'>
//         <button onClick={handleClose}>{"Clear Filter"}</button>
//         <button onClick={handleClose}>{"Apply Filter"}</button>
//       </div>
//     */}
//     </div>
//   );
// };

// export default FilterDropdown;

import { Button, Paper, Stack } from "@mui/material";
import { format } from "date-fns";
import { useState } from "react";
import { DateRangePicker } from "materialui-daterange-picker";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { StyledBox } from "components/shared/filterSearchExport/transactionHeader/SettlementFSE";

const FilterDropdown = ({
  values,
  onChange,
  onApply,
  onClear,
  close,
}) => {
  const [open, setOpen] = useState(false);

  const toggle = () => setOpen(!open);

  const handleChange = (event) => {
    const { name, value } = event.target;

    onChange((prev) => ({
      ...prev,
      [name]: value === "Show All" ? "" : value,
    }));
  };

  const handleDateChange = ({ startDate, endDate }) => {
    onChange((prev) => ({
      ...prev,
      startDate: format(startDate, "yyyy-MM-dd"),
      endDate: format(endDate, "yyyy-MM-dd"),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onApply?.();
    close?.();
  };

  const handleClear = () => {
    onClear?.();
    close?.();
  };

  return (
    <Paper sx={{ p: 2 }}>
      <form onSubmit={handleSubmit} onChange={handleChange}>
        

        <StyledBox>
          <label>Request Status</label>
          <select name="merchantStatus" value={values.merchantStatus || ""}>
            <option value="">Show All</option>
            <option value="REJECTED">Rejected</option>
            <option value="APPROVED">Approved</option>
            <option value="PENDING">Pending</option>
            <option value="FAILED">Failed</option>
          </select>
        </StyledBox>

        <StyledBox sx={{ mb: 1 }}>
          <label>Date Range</label>
          <Paper elevation={1} sx={{ p: 2, width: "fit-content" }}>
            <Stack direction="row">
              {"From : "}
              <Button endIcon={<ArrowDropDownIcon />} onClick={toggle}>
                {values.startDate || "Select"}
              </Button>

              {"To : "}
              <Button endIcon={<ArrowDropDownIcon />} onClick={toggle}>
                {values.endDate || "Select"}
              </Button>
            </Stack>

            <DateRangePicker
              open={open}
              toggle={toggle}
              onChange={handleDateChange}
            />
          </Paper>
        </StyledBox>

        <Stack direction="row" justifyContent="space-between">
          <Button variant="outlined" onClick={handleClear}>
            Clear
          </Button>

          <Button variant="contained" type="submit">
            Apply
          </Button>
        </Stack>
      </form>
    </Paper>
  );
};

export default FilterDropdown;